<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [ngStyle]="overrideStyle"
>
  <path
    d="M10.1423 12.5817C10.1423 13.001 9.65737 13.234 9.32999 12.9721L3.88038 8.61245C3.63017 8.41229 3.63017 8.03175 3.88038 7.83159L9.32999 3.4719C9.65737 3.20999 10.1423 3.44308 10.1423 3.86233V12.5817Z"
    fill="white"
  />
  <path
    d="M11.8099 3.22827C11.3145 3.22827 10.8928 3.50679 10.8928 3.85605V12.5079C10.8593 13.3434 12.8006 13.3434 12.7671 12.5079V3.85605C12.8006 3.50679 12.3387 3.22827 11.8099 3.22827Z"
    fill="white"
  />
</svg>
